import RoutesEnum from '../../../../enums/RoutesEnum';

const privacy = [
    { to: RoutesEnum.TERMS_OF_USE, label: 'Terms of use' },
    { to: RoutesEnum.PRIVACY, label: 'Privacy policy' },
    { to: RoutesEnum.COOKIES, label: 'Cookie policy' },
];

export default privacy;
